<template>
    <v-progress-circular v-if="resourceLimitFetching" color="primary" indeterminate class="ml-2"></v-progress-circular>

    <div v-else-if="collapsed" class="d-flex justify-center align-center flex-column">
        <v-progress-linear rounded :value="cpuUsage" :color="cpuColor" height="5"></v-progress-linear>
        <div class="caption">{{ cpuLimit }} vCPU</div>
        <v-progress-linear rounded :value="memoryUsage" :color="memoryColor" height="5"></v-progress-linear>
        <div class="caption">{{ memoryLimitAbs }} GB</div>
    </div>
    <div v-else class="d-flex align-center justify-center">
        <v-card flat class="d-flex align-center pa-2 mr-2">
            <div class="caption mr-2">{{ cpuLimit }} vCPU</div>
            <v-progress-circular :value="cpuUsage" :color="cpuColor" size="28" width="3">
                <span class="caption">{{ cpuUsage }}</span>
            </v-progress-circular>
        </v-card>
        <v-card flat class="d-flex align-center pa-2">
            <div class="caption mr-2">{{ memoryLimitAbs }} GB</div>
            <v-progress-circular :value="memoryUsage" :color="memoryColor" size="28" width="3">
                <span class="caption">{{ memoryUsage }}</span>
            </v-progress-circular>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        currentApp: {
            type: Object,
            default: null
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            resourceLimit: null,
            resourceLimitFetching: true
        }
    },
    computed: {
        isFractional() {
            return Boolean(this.currentApp && this.currentApp.node_pool && this.currentApp.node_pool.includes('-hami'))
        },
        fractionMultiplier() {
            if (this.isFractional && this.resourceLimit !== null) {
                return this.resourceLimit / 100
            }
            return 1
        },
        memoryLimitAbs() {
            if (this.currentApp && this.currentApp.limit_memory !== 'N/A') {
                return ((parseFloat(this.currentApp.limit_memory.replace('M', '')) / 1000) * this.fractionMultiplier).toFixed(0)
            }
            return 0
        },
        memoryUsage() {
            if (this.currentApp && this.currentApp.limit_memory !== 'N/A' && this.currentApp.current_memory !== 'N/A') {
                const limitMemory = parseFloat(this.currentApp.limit_memory.replace('M', ''))
                if (limitMemory <= 0) {
                    return 0
                }
                const currentMemory = parseFloat(this.currentApp.current_memory.replace('M', ''))
                return Math.round((100 * currentMemory) / limitMemory)
            }
            return 0
        },
        memoryColor() {
            if (this.memoryUsage < 90) {
                return 'info'
            }
            return 'error'
        },
        cpuUsage() {
            if (this.currentApp && this.currentApp.limit_cpu !== 'N/A' && this.currentApp.current_cpu !== 'N/A') {
                const limitCPU = parseFloat(this.currentApp.limit_cpu.replace('m', ''))
                if (limitCPU <= 0) {
                    return 0
                }
                const currentCPU = parseFloat(this.currentApp.current_cpu.replace('m', ''))
                return Math.round((100 * currentCPU) / limitCPU)
            }
            return 0
        },
        cpuColor() {
            if (this.cpuUsage < 90) {
                return 'success'
            }
            return 'error'
        },
        memoryLimit() {
            if (this.currentApp) {
                return this.currentApp.limit_memory
            }
            return 0
        },
        cpuLimit() {
            if (this.currentApp && this.currentApp.limit_cpu !== 'N/A') {
                const limit = (parseFloat(this.currentApp.limit_cpu.replace('m', '')) / 1000) * this.fractionMultiplier
                return Math.round(limit * 10) / 10
            }
            return 0
        }
    },
    mounted() {
        this.fetchResourceLimit()
        this.$emit('memoryLimit', { value: this.memoryLimit })
    },
    methods: {
        fetchResourceLimit() {
            if (!this.isFractional || !this.currentApp || !this.currentApp.aid) {
                this.resourceLimit = null
                this.resourceLimitFetching = false
                return
            }
            this.$axios
                .get(`/applications/${this.currentApp.aid}/config`)
                .then(({ data }) => {
                    this.resourceLimit = data.hami_resource_limit || 100
                    this.resourceLimitFetching = false
                })
                .catch(err => {
                    console.error(err)
                    this.resourceLimit = null
                    this.resourceLimitFetching = false
                })
        }
    },
    watch: {
        memoryUsage: {
            immediate: true,
            handler: function (to, from) {
                if (to > 90 && from < 90) {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'You are nearing the memory limit where the application will be restarted!',
                        snackBarIcon: 'error',
                        snackBarTimeout: 10000
                    })
                }
            }
        },
        memoryLimit: function (nextVal) {
            this.$emit('memoryLimit', { value: nextVal })
        }
    }
}
</script>
